// Recovered compiled webpack factory 23982. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      describeHasCheckingStringProperty: function () {
        return a;
      },
      describeStringPropertyAccess: function () {
        return n;
      },
      wellKnownProperties: function () {
        return o;
      },
    }));
  let r = /^[A-Za-z_$][A-Za-z0-9_$]*$/;
  function n(e, t) {
    return r.test(t) ? "`" + e + "." + t + "`" : "`" + e + "[" + JSON.stringify(t) + "]`";
  }
  function a(e, t) {
    let r = JSON.stringify(t);
    return "`Reflect.has(" + e + ", " + r + ")`, `" + r + " in " + e + "`, or similar";
  }
  let o = new Set([
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toString",
    "valueOf",
    "toLocaleString",
    "then",
    "catch",
    "finally",
    "status",
    "displayName",
    "_debugInfo",
    "toJSON",
    "$$typeof",
    "__esModule",
  ]);
}
